import React from "react";
import clsx from "clsx";
import { TableContainer as MuiTableContainer } from "@mui/material";
import { useStyles } from "./TableContainer.styles";
import { TableContainerProps } from "./TableContainer.types";

function TableContainer(props: TableContainerProps) {
  const { allowPan, className, ...other } = props;

  const classes = useStyles();

  const rootRef = React.useRef<HTMLDivElement>(null);

  const movingRef = React.useRef(false);

  const startPointRef = React.useRef({ x: 0, y: 0 });

  const startScrollRef = React.useRef({ x: 0, y: 0 });

  const handleDocumentMouseUp = React.useCallback(() => {
    movingRef.current = false;
    if (rootRef.current) {
      rootRef.current.style.userSelect = "initial";
    }
    document.removeEventListener("mouseup", handleDocumentMouseUp);
  }, []);

  const handleMouseOver = React.useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      if (rootRef.current) {
        const target = event.currentTarget;
        const hasScroll = target.scrollWidth > target.clientWidth;
        rootRef.current.style.cursor = hasScroll ? "grab" : "default";
      }
    },
    []
  );

  const handleMouseDown = React.useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      startPointRef.current = {
        x: event.pageX,
        y: event.pageY,
      };
      startScrollRef.current = {
        x: rootRef.current?.scrollLeft || 0,
        y: rootRef.current?.scrollTop || 0,
      };
      movingRef.current = true;
      if (rootRef.current) {
        rootRef.current.style.userSelect = "none";
      }
      document.addEventListener("mouseup", handleDocumentMouseUp);
    },
    [handleDocumentMouseUp]
  );

  const handleMouseMove = React.useCallback((event: React.MouseEvent) => {
    if (movingRef.current) {
      const deltaX = event.pageX - startPointRef.current.x;
      rootRef.current?.scrollTo(startScrollRef.current.x - deltaX, 0);
    }
  }, []);

  React.useEffect(() => {
    return () => {
      document.removeEventListener("mouseup", handleDocumentMouseUp);
    };
  }, [handleDocumentMouseUp]);

  const rootClassName = clsx(className, classes.root);

  return (
    <MuiTableContainer
      {...other}
      ref={rootRef}
      className={rootClassName}
      onMouseOver={handleMouseOver}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
    />
  );
}

export default TableContainer;
